import React, { useEffect, useState } from "react";
import "./Login.css";
import { Link, useHistory } from "react-router-dom";
import { auth, provider } from "../firebase";
import logo from "../img/logo.svg";
import { db, storage } from "../firebase";
function Signup() {
  const history = useHistory();
  const [name, setName] = useState("");
  const [dept, setDept] = useState("");
  const [type, setType] = useState(0);
  const [institute, setinstitute] = useState("");
  const [location, setLocation] = useState("");
  const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(logo);
  const [progress, setProgress] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [withImage, setWithImage] = useState(false);

  useEffect(() => {
    document.title = `Signup to Accelerator`;
  }, []);

  const register = (e) => {
    e.preventDefault();

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        if (auth.uid);
        if (auth) {
          if (withImage) {
            const imageName = `${image.name}${
              Math.floor(Math.random() * (9999 - 1000)) + 1000
            }`;
            const uploadTask = storage.ref(`images/${imageName}`).put(image);
            uploadTask.on(
              "state_changed",
              (snapshot) => {
                const progress = Math.round(
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                setProgress(progress);
              },

              (error) => {
                console.log(error);
                alert(error.message);
              },
              () => {
                storage
                  .ref("images")
                  .child(imageName)
                  .getDownloadURL()
                  .then((url) => {
                    db.collection("Users")
                      .doc(auth.uid)
                      .set({
                        id: auth.uid,
                        name: name,
                        institute: institute,
                        dept: dept,
                        image: url,
                        email: email,
                        bio: "",
                        username: name.split(" ").at(0),
                        location: location,
                        score: 500,
                        win: 0,
                        lose: 0,
                        draw: 0,
                        type: type,
                        reward: 100,
                        solved: 0,
                        answers: 0,
                        vote: 0,
                        lastTimestamp: String(new Date().getTime()),
                      });
                    setProgress(0);
                    setImage(null);
                    setFileName("");
                    setFile(null);
                    closeUpload();
                    document
                      .getElementById("root")
                      .scrollIntoView({ behavior: "smooth" });
                  });
              }
            );
          } else {
            db.collection("Users")
              .doc(auth.uid)
              .set({
                id: auth.uid,
                name: name,
                institute: institute,
                dept: dept,
                image:
                  "https://scontent.fdac31-1.fna.fbcdn.net/v/t39.30808-6/275807644_333623582154002_997074479579421597_n.jpg?_nc_cat=111&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=jmxGWuYmQUYAX8FsqEb&tn=lBHiCD2VMYZ_Ro12&_nc_ht=scontent.fdac31-1.fna&oh=00_AT89-uasohogrU0Gbg7LVQdJWqQa1OJukBunh_s-MRbeYA&oe=6237904E",
                email: email,
                bio: "",
                username: name.split(" ").at(0),
                location: location,
                score: 500,
                win: 0,
                lose: 0,
                draw: 0,
                type: type,
                reward: 100,
                solved: 0,
                answers: 0,
                vote: 0,
                lastTimestamp: new Date().getTime(),
              });
          }
          history.push("/");
        }
      })
      .catch((error) => alert(error.message));
  };

    
  const login = (user) => {
    try{
      db.collection("Users")
      .doc(user.uid)
      .get()
      .then((ds) => {
        if(ds.data()){
          history.push("/");
          alert("Welcome Back!")
        }else{
          db.collection("Users")
          .doc(user.uid)
          .set({
            id: user.uid,
            name: user.displayName,
            institute: "",
            dept: "",
            image: user.photoURL,
            email: user.email,
            bio: "",
            username: user.displayName.split(" ").at(0),
            location: "",
            score: 500,
            win: 0,
            lose: 0,
            draw: 0,
            type: 0,
            reward: 100,
            solved: 0,
            answers: 0,
            vote: 0,
            lastTimestamp: new Date().getTime()
          });
          history.push("/");
        }
      });
    }catch(e){
      db.collection("Users")
          .doc(user.uid)
          .set({
            id: user.uid,
            name: user.displayName,
            institute: "",
            dept: "",
            image: user.photoURL,
            email: user.email,
            bio: "",
            username: user.displayName.split(" ").at(0),
            location: "",
            score: 500,
            win: 0,
            lose: 0,
            draw: 0,
            type: 0,
            reward: 100,
            solved: 0,
            answers: 0,
            vote: 0,
            lastTimestamp: String(new Date().getTime()),
          });
          history.push("/");
    }
  };

  const signIn = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {
        login(result.user);
      })
      .catch((error) => {
         alert(error.message);
      });
  };
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setWithImage(true);
    }
    setFile(URL.createObjectURL(e.target.files[0]));

    var a = e.target.value.toString().split("\\");
    var name = a[a.length - 1];
    if (name.length > 20)
      name =
        name.split(".")[0].substring(0, 20) +
        "...." +
        name.split(".")[name.split(".").length - 1];
    setFileName(name);
  };
  const closeUpload = () => {
    document.querySelector(".upload").style.display = "none";
    document.querySelector(".filter").style.display = "none";
  };

  return (
    <div className="login">
      <div className="loginContainer">
        <Link to="/" className="link">
          <h1 className="loginLogo">Accelerator</h1>
        </Link>
        <h1>Create Account</h1>

        <div className="uploadss">
          <label htmlFor="file-upload" className="customFileUpload">
            <img className="profileAvatar" src={file} alt={fileName} />
          </label>
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>

        <progress
          className="ui indicating progress"
          value={progress}
          max="100"
        ></progress>

        <form>
          <h5>Name</h5>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <h5>E-mail</h5>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <h5>Class Level</h5>
          <select
            className=""
            value={type}
            onChange={(e) => setType(parseInt(e.target.value))}
          >
            <option value="0">BSC</option>
            <option value="1">HSC</option>
            <option value="2">SSC</option>
            <option value="3">Others</option>
          </select>

          <h5>Depertment Name</h5>
          <input
            type="text"
            value={dept}
            onChange={(e) => setDept(e.target.value)}
          />

          <h5>Institute Name</h5>
          <input
            type="text"
            value={institute}
            onChange={(e) => setinstitute(e.target.value)}
          />

          <h5>Location</h5>
          <select
            className=""
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          >
            <option value="Bagerhat">Bagerhat</option>
            <option value="Bandarban">Bandarban</option>
            <option value="Barguna">Barguna</option>
            <option value="Barisal">Barisal</option>
            <option value="Bhola">Bhola</option>
            <option value="Bogra">Bogra</option>
            <option value="Brahmanbaria">Brahmanbaria</option>
            <option value="Chandpur">Chandpur</option>
            <option value="Chittagong">Chittagong</option>
            <option value="Chuadanga">Chuadanga</option>
            <option value="Comilla">Comilla</option>
            <option value="Cox'sBazar">Cox'sBazar</option>
            <option value="Dhaka">Dhaka</option>
            <option value="Dinajpur">Dinajpur</option>
            <option value="Faridpur">Faridpur</option>
            <option value="Feni">Feni</option>
            <option value="Gaibandha">Gaibandha</option>
            <option value="Gazipur">Gazipur</option>
            <option value="Gopalganj">Gopalganj</option>
            <option value="Habiganj">Habiganj</option>
            <option value="Jaipurhat">Jaipurhat</option>
            <option value="Jamalpur">Jamalpur</option>
            <option value="Jessore">Jessore</option>
            <option value="Jhalokati">Jhalokati</option>
            <option value="Jhenaidah">Jhenaidah</option>
            <option value="Khagrachari">Khagrachari</option>
            <option value="Khulna">Khulna</option>
            <option value="Kishoreganj">Kishoreganj</option>
            <option value="Kurigram">Kurigram</option>
            <option value="Kushtia">Kushtia</option>
            <option value="Lakshmipur">Lakshmipur</option>
            <option value="Lalmonirhat">Lalmonirhat</option>
            <option value="Madaripur">Madaripur</option>
            <option value="Magura">Magura</option>
            <option value="Manikganj">Manikganj</option>
            <option value="Maulvibazar">Maulvibazar</option>
            <option value="Meherpur">Meherpur</option>
            <option value="Munshiganj">Munshiganj</option>
            <option value="Mymensingh">Mymensingh</option>
            <option value="Naogaon">Naogaon</option>
            <option value="Narail">Narail</option>
            <option value="Narayanganj">Narayanganj</option>
            <option value="Narsingdi">Narsingdi</option>
            <option value="Natore">Natore</option>
            <option value="Nawabganj">Nawabganj</option>
            <option value="Netrokona">Netrokona</option>
            <option value="Nilphamari">Nilphamari</option>
            <option value="Noakhali">Noakhali</option>
            <option value="Pabna">Pabna</option>
            <option value="Panchagarh">Panchagarh</option>
            <option value="Patuakhali">Patuakhali</option>
            <option value="Pirojpur">Pirojpur</option>
            <option value="Rajbari">Rajbari</option>
            <option value="Rajshahi">Rajshahi</option>
            <option value="Rangamati">Rangamati</option>
            <option value="Rangpur">Rangpur</option>
            <option value="Satkhira">Satkhira</option>
            <option value="Shariatpur">Shariatpur</option>
            <option value="Sherpur">Sherpur</option>
            <option value="Sirajganj">Sirajganj</option>
            <option value="Sunamganj">Sunamganj</option>
            <option value="Sylhet">Sylhet</option>
            <option value="Tangail">Tangail</option>
            <option value="Thakurgaon">Thakurgaon</option>
          </select>

          <h5>Password</h5>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            type="submit"
            onClick={register}
            disabled={!name && !email && !password}
            className="loginSignInButton"
          >
            Create Account
          </button>
        </form>

        <br />
        <h5>OR</h5>
        <button onClick={signIn} className="loginSignInButtonGoogle">
          <i className="fab fa-google"></i> Sign In with Google
        </button>

        <p>
          This is a experimental education community platfrom initated by
          <Link to="/post/about_app">Jahangir Hossain.</Link>
        </p>
      </div>
    </div>
  );
}

export default Signup;
